import { portfolio } from "../data/portfolio";
import { SectionHead } from "../components/SectionHead";

export function Awards() {
  return (
    <section id="awards" className="md-section">
      <div className="md-container">
        <SectionHead num="08" eyebrow="Awards & Honors" title="Recognition along the way." />
        <div className="m3-awards-grid">
          {portfolio.awards.map((a, i) => (
            <div key={i} className="md-card md-card--outlined m3-award">
              <div className="m3-award__img">
                {a.image ? (
                  <img
                    src={`${import.meta.env.BASE_URL}${a.image}`}
                    alt={a.title}
                    loading="lazy"
                  />
                ) : (
                  <div className="m3-award__placeholder">
                    <span className="material-symbols-rounded icon-40">workspace_premium</span>
                  </div>
                )}
              </div>
              <div className="m3-award__body">
                <div className="m3-award__year md-label-l">{a.year}</div>
                <div style={{ minWidth: 0 }}>
                  <div className="md-title-m">{a.title}</div>
                  <div className="md-body-s dim" style={{ marginTop: 4 }}>
                    {a.note}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
